/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IChangeStateSettingsModalControllerScope extends IBaseModalControllerScope {
        workflowBlock: models.ChangeStateWorkflowBlock;
        statusGroup: Wars.Domain.Model.Statuses.StatusCodeGroup;
        states: Wars.Domain.Model.Statuses.StateCode[];
        isReadonly: boolean;
        statusChange: () => void;
    }

    export class ChangeStateSettingsModalController extends BaseModalController {
        scope: IChangeStateSettingsModalControllerScope;

        constructor(
            $scope: IChangeStateSettingsModalControllerScope,
            statusAndStateService: services.StatusAndStateService,
            workflowBlock: models.ChangeStateWorkflowBlock,
            processConfigId: string,
            isReadonly: boolean, close: any)
        {
            super($scope, close);
            this.scope = $scope;
            this.scope.workflowBlock = workflowBlock;
            statusAndStateService.getStatusAndStatesByProcessConfig(processConfigId).then(
                (statusGroup) => {
                    this.scope.statusGroup = statusGroup;
                    if (this.scope.workflowBlock.changeStateDto.statusCodeId) {
                        this.statusChangeInternal();
                    }
                });
            this.scope.isReadonly = isReadonly;

            this.scope.statusChange = () => this.statusChangeInternal();
        }


        private statusChangeInternal(): void {
            if (!this.scope.workflowBlock.changeStateDto.statusCodeId ||
                !this.scope.statusGroup)
            {
                this.scope.states = [];
                return;
            }

            var status = Enumerable.from(this.scope.statusGroup.myStatuses).singleOrDefault(i => i.id === this.scope.workflowBlock.changeStateDto.statusCodeId);
            if (!status) {
                this.scope.states = [];
                return;
            }

            this.scope.states = status.myStates;
        }
    }
}

warsApp.registerController('ChangeStateSettingsModalController', ['$scope', 'statusAndStateService', 'workflowBlock', 'processConfigId', 'isReadonly', 'close']);